import axios from "axios";

// Création d'une instance Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001",
  withCredentials: true, // toujours envoyé pour CORS
});

// 🔐 Intercepteur de requête : ajoute automatiquement le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const isTwoFaLogin = config.url.includes("/login/2fa");
    if (token && !config.url.includes("/authRefresh/refresh-token")) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const skip401Routes = [
  "/api/users/login/2fa",
  "/api/users/login",
  "/api/users/setup-2fa"
];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const url = originalRequest.url;

    if (error.response?.status === 401 && !originalRequest._retry) {
      // 🚫 Skip certaines routes
      if (skip401Routes.some(route => url.includes(route))) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/authRefresh/refresh-token`,
            { refreshToken },
            { withCredentials: true }
          );

          const { token: newAccessToken, refreshToken: newRefreshToken } = res.data;

          if (!newAccessToken) throw new Error("Pas de nouveau token reçu");

          localStorage.setItem("token", newAccessToken);
          if (newRefreshToken) localStorage.setItem("refreshToken", newRefreshToken);

          api.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          return api(originalRequest);
        } catch (refreshError) {
          console.error("❌ Échec du refresh token :", refreshError);
          localStorage.clear();
          window.location.hash = "#/connexion";
        }
      } else {
        localStorage.clear();
        window.location.hash = "#/connexion";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
